import { gql } from '@apollo/client'

import { DICTIONARY_WORD_FRAGMENT } from '../fragments'

const UPDATE_DICTIONARY_WORD_MUTATION = gql`
  mutation updateDictionaryWord($id: ID!, $data: DictionaryWordInput!) {
    updateDictionaryWord(id: $id, data: $data) {
      ...DictionaryWordFragment
    }
  }
  ${DICTIONARY_WORD_FRAGMENT}
`

export default UPDATE_DICTIONARY_WORD_MUTATION
